import { LanguageCode } from '@sparted/shared-library/business/types';
import { fetchFactory } from 'Libs/http/utils';
import { MultilingualLabel } from 'Services/language/languageService';

type FetchTranslationsResponse = { multilingualLabels: Array<MultilingualLabel & { id: number }> };

type FetchTranslationsParams = {
  sourceLanguageCode: LanguageCode;
  targetLanguageCode: LanguageCode;
  multilingualLabelIds: number[];
};

export const fetchTranslations = async ({
  sourceLanguageCode,
  targetLanguageCode,
  multilingualLabelIds,
}: FetchTranslationsParams) => {
  const { fetchFn } = fetchFactory<FetchTranslationsResponse>({
    route: `/api/languages/translator/translate`,
    method: 'POST',
    payload: {
      sourceLanguageCode,
      targetLanguageCode,
      multilingualLabelIds,
    },
  });

  return fetchFn();
};
